export default __webpack_public_path__ + "static/media/settings.ae25ce68.svg";